export * from './ProductDetailsCardCarouselDots';
